/**
 * Generated by orval v6.16.0 🍺
 * Do not edit manually.
 * Neubie Order
 * Neubie Order API Server
 * OpenAPI spec version: V1
 */

/**
 * * `USER_NOT_FOUND` - 해당 유저가 존재하지 않습니다.
 * `PASSWORD_VALIDATION_FAILED` - 비밀번호 최소 길이 8자 이상, 특수문자, 숫자, 대문자, 소문자 중 최소 3개가 포함되어야 합니다.
 * `INVALID_USER_INFO` - 사용자 정보가 잘못되었습니다.
 */
export type UserResetPassword404ExceptionCodeEnum =
  (typeof UserResetPassword404ExceptionCodeEnum)[keyof typeof UserResetPassword404ExceptionCodeEnum]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserResetPassword404ExceptionCodeEnum = {
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  PASSWORD_VALIDATION_FAILED: 'PASSWORD_VALIDATION_FAILED',
  INVALID_USER_INFO: 'INVALID_USER_INFO'
} as const
